//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    MESSAGE_TEMPLATE_DELETE_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    messageTemplateDeleteResult,
} from 'Redux/actions';


function* deleteMessageTemplate({ payload }) {
    try {
        let QUERY = `
            mutation deleteMessageTemplate ($id: Int!) {
                result: deleteMessageTemplate (id: $id)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(messageTemplateDeleteResult({ delete: data?.result }))
        } else yield put(messageTemplateDeleteResult({ error: 'delete-messageTemplate' }))

    } catch (exc) {
        yield put(messageTemplateDeleteResult({ error: exc.error }))
        ExceptionManager(exc, 'Modules/brands/views/.components/deleteMessageTemplate/redux/saga', 'deleteMessageTemplate');
    }
}

function* watchMessageTemplateRequests() {
    yield takeEvery(MESSAGE_TEMPLATE_DELETE_REQUEST, deleteMessageTemplate);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchMessageTemplateRequests)
    ]);
}